import {
  Box,
  CircularProgress,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useEffect } from 'react'
import { useAppDispatch } from 'store/hooks'
import { actions as dashboardActions } from 'store/dashboard'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useParams } from 'react-router-dom'

// Company searches list is only available for admin. Be careful not to mistake this component with MultisectorList, because Multisector list has as title "Company searches"
export default function CompanySearchesTable() {
  const { id } = useParams<string>()
  const dispatch = useAppDispatch()
  const data = useSelector((state: RootState) => state.dashboard.companySearchesList)
  const isLoading = useSelector((state: RootState) => state.dashboard.loading.companySearchesList)
  const error = useSelector((state: RootState) => state.dashboard.error.companySearchesList)
  useEffect(() => {
    if (id) dispatch(dashboardActions.fetchCompanySearchesList(id))
  }, [dispatch, id])

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Company Names</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Created at</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.map(row => (
              <TableRow hover>
                <TableCell>
                  <Link
                    href={`/company/${row.completion_action_type === 'benchmark' ? 'benchmark' : 'search'}/${row.ID}`}
                    target="_blank"
                    style={{ display: 'flex', gap: 4 }}>
                    <Box mt={0.2}>{row.company_names}</Box> <OpenInNewIcon sx={{ fontSize: 13 }} />
                  </Link>
                </TableCell>
                <TableCell>{row.completion_action_type}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.created_at}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {data && data?.length === 0 && <Stack p={2}>No company searches created</Stack>}
      <Box sx={{ textAlign: 'center', width: 1 }}>
        {isLoading && <CircularProgress />}
        {error && (
          <Typography p={1} color={'red'}>
            {error}
          </Typography>
        )}
      </Box>
    </TableContainer>
  )
}
